import { useState, useEffect } from 'react';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import PageHeader from '@/components/ui/page-header';
import ProfileForm from '@/components/ProfileForm';
import { ResponsiveContainer } from '@/components/ResponsiveContainer';
import AdminJsonToggle from '@/components/AdminJsonToggle';


const Profile = () => {
  const { data: user } = useCurrentUser();
  const [formData, setFormData] = useState(user);
  const [errors, setErrors] = useState<Record<string, string>>({});



  return (
    <div className="min-h-screen bg-white">
      <AdminJsonToggle 
        data={{
          user,
          formData,
          errors
        }}
        label="Profile Data"
      />
      <PageHeader 
        title="Profile"
        variant="title-only"
      />
      <ResponsiveContainer maxWidth="7xl" className="py-8 lg:py-12">
        <div className="mb-8">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-black mb-4">Complete Your Profile</h1>
          <p className="text-lg lg:text-xl text-gray-600">Tell us about yourself so we can personalize your experience.</p>
        </div>
        <ProfileForm 
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
        />
      </ResponsiveContainer>
    </div>
  );
};

export default Profile;
